import { Box, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { RichTextEditor, RichTextReadOnly } from '@/components/common/RichTextEditor';

interface FeedbackItemProps {
  content: string;
  onChange: (content: string) => void;
  onBlur?: () => void;
  onDelete: () => void;
  canEdit: boolean;
  canDelete: boolean;
  placeholder?: string;
  error?: boolean;
}

export function FeedbackItem({
  content,
  onChange,
  onBlur,
  onDelete,
  canEdit,
  canDelete,
  placeholder,
  error,
}: FeedbackItemProps) {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Box
        sx={{
          flex: 1,
          ...(error && {
            border: '2px solid',
            borderColor: 'error.main',
            borderRadius: 1,
          }),
        }}
      >
        {canEdit ? (
          <RichTextEditor
            content={content}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={placeholder}
          />
        ) : (
          <RichTextReadOnly content={content} />
        )}
      </Box>
      {canEdit && (
        <IconButton
          onClick={onDelete}
          color="error"
          size="small"
          disabled={!canDelete}
          aria-label="Delete feedback item"
        >
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
}

export default FeedbackItem;
